import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/ffl')({
    component: () => _jsx(Outlet, {})
});
if (import.meta.hot) {
    import.meta.hot.accept(newModule => {
        if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
            newModule.Route.clone(Route);
        }
    });
}
